<div class="button-row text-right">
  <span
    class="visible-md visible-sm visible-xs text-right"
    [shown]="editorService.presentation.id"
  >
    <last-revised
      [revisionStatusName]="editorService.presentation.revisionStatusName"
      [changeDate]="editorService.presentation.changeDate"
      [changedBy]="editorService.presentation.changedBy"
    ></last-revised>
  </span>
  <div class="pull-left hidden-xs">
    @if (!artboardService.designMode) {
      <button
        id="designButton"
        class="btn btn-link pl-0"
        (click)="artboardService.showArtboard()"
      >
        Design View
      </button>
    } @else {
      <button
        id="htmlButton"
        class="btn btn-link pl-0"
        (click)="artboardService.showHtmlEditor()"
      >
        HTML View
      </button>
    }
  </div>
  @if (editorService.presentation?.id) {
    <span class="hidden-md hidden-sm hidden-xs save-status">
      <last-revised
        [revisionStatusName]="editorService.presentation.revisionStatusName"
        [changeDate]="editorService.presentation.changeDate"
        [changedBy]="editorService.presentation.changedBy"
      ></last-revised>
    </span>
  }
  @if (editorService.canPublishPresentation()) {
    <button
      matButton="outlined"
      id="restoreButton"
      [disabled]="
        !editorService.presentation.id ||
        (!editorService.isRevised() && !editorService.hasUnsavedChanges) ||
        editorService.savingPresentation
      "
      (click)="editorService.confirmRestorePresentation()"
    >
      Restore
    </button>
  }
  @if (editorService.canEditPresentation()) {
    <button
      matButton="outlined"
      id="saveButton"
      type="submit"
      (click)="editorService.save()"
      [disabled]="editorService.savingPresentation"
    >
      {{ editorService.savingPresentation ? 'Saving' : 'Save' }}
    </button>
  }
  @if (editorService.canPublishPresentation()) {
    <button
      id="publishButton"
      class="btn btn-primary btn-toolbar"
      [disabled]="
        editorService.hasUnsavedChanges ||
        !editorService.isRevised() ||
        editorService.savingPresentation
      "
      (click)="editorService.publishPresentation()"
    >
      Publish
    </button>
  }
</div>
